export default __webpack_public_path__ + "static/334-8815eefe44df4295d564b41d9561ec47.gif";